<template>
  <b-row v-if="filteredData.length != 0">
    <b-col
      v-for="field in filteredData"
      :key="field.label"
      :cols="columnWidth(field.controlType)"
      :class="field.controlType == 'boolean' ? 'd-flex align-items-center' : ''"
    >
      <div
        v-if="
          field.controlType == 'text' ||
          field.controlType == 'email' ||
          field.controlType == 'number'
        "
        class="topDiv mt-3"
      >
        <inputField
          :disabled="true"
          :type="field.controlType"
          :label="field.label"
          :mandatory="field.mandatory"
          :placeholder="field.placeholder"
          :id="field.key"
        />
      </div>
      <div v-else-if="field.controlType == 'single_select'" class="topDiv mt-3">
        <SelectCustom
          :disabled="true"
          :label="field.label"
          :mandatory="field.mandatory"
          :placeholder="field.placeholder"
          :id="field.key"
          :api="field.apiEndpoint"
          :values="field.values"
          :dropdown="field.dropdown"
          :fieldType="field.fieldType"
        />
      </div>

      <div v-else-if="field.controlType == 'multi_select'" class="topDiv mt-3">
        <MultiSelectCustom
          :disabled="true"
          :label="field.label"
          :mandatory="field.mandatory"
          :placeholder="field.placeholder"
          :id="field.key"
          :api="field.apiEndpoint"
          :values="field.values"
          :dropdown="field.dropdown"
          :fieldType="field.fieldType"
        />
      </div>
      <div v-else-if="field.controlType == 'rich_text_box'" class="topDiv mt-3">
        <CustomQuillEditor
          :disabled="true"
          :type="field.controlType"
          :label="field.label"
          :mandatory="field.mandatory"
          :placeholder="field.placeholder"
          :id="field.key"
        />
      </div>
      <div v-else-if="field.controlType == 'boolean'" class="topDiv mt-4">
        <SwitchBox
          :disabled="true"
          :type="field.controlType"
          :label="field.label"
          :mandatory="field.mandatory"
          :placeholder="field.placeholder"
          :id="field.key"
        />
      </div>

      <div v-else-if="field.controlType == 'upload_file'" class="topDiv mt-3">
        <UploadDocument
          :disabled="true"
          :type="field.controlType"
          :label="field.label"
          :mandatory="field.mandatory"
          :placeholder="field.placeholder"
          :id="field.key"
          :fileFormat="field.fileFormat"
          :maxFileSize="field.maxFileSize"
        />
      </div>
      <div v-else-if="field.controlType == 'multi_text'" class="topDiv mt-3">
        <FormTags
          :disabled="true"
          :type="field.controlType"
          :label="field.label"
          :mandatory="field.mandatory"
          :placeholder="field.placeholder"
          :id="field.key"
          @handle-input="handleInput(field)"
          @handle-blur="handleBlur(field)"
        />
      </div>
      <div v-else-if="field.controlType == 'date'" class="topDiv mt-3">
        <DateField
          :type="field.controlType"
          :label="field.label"
          :mandatory="field.mandatory"
          :placeholder="field.placeholder"
          :id="field.key"
          :fromCust="true"
          :format="field.dateTimeFormat"
        />
      </div>
    </b-col>
  </b-row>
</template>

<script>
import inputField from "../../components/InputComponents/Input";
import CustomQuillEditor from "../../components/InputComponents/CustomQuillEditor";
import SelectCustom from "../../components/InputComponents/SelectCustom";
import MultiSelectCustom from "../../components/InputComponents/MultiSelectCustom";
import SwitchBox from "../../components/InputComponents/Switch";
import UploadDocument from "../../components/InputComponents/UploadDocument";
import FormTags from "../../components/InputComponents/FormTags";
import DateField from "../../components/InputComponents/DateField";

export default {
  name: "CustomPreview",
  props: {
    fieldData: Array,
    data: Array,
  },
  data() {
    return {
      localData: [],
    };
  },
  created() {
    this.localData = JSON.parse(JSON.stringify(this.data));
  },
  components: {
    inputField,
    CustomQuillEditor,
    SelectCustom,
    MultiSelectCustom,
    SwitchBox,
    UploadDocument,
    FormTags,
    DateField,
  },
  computed: {
    filteredData() {
      return this.localData.filter((obj) => obj.hide != true);
    },
  },
  methods: {
    handleSelected(field, val) {
      if (
        (field.key == "source" || field.key == "noticePeriod") &&
        val == "other"
      ) {
        let value = this.localData.findIndex(
          (obj) =>
            obj.hide == true &&
            (obj.parentKey == field.key || obj.seq == field.seq)
        );

        if (value != -1) {
          this.localData[value].seq = field.seq;
          this.localData[value].hide = false;
        } else {
          let val = this.fieldData.find(
            (obj) =>
              obj.hide == true &&
              (obj.parentKey == field.key || obj.seq == field.seq)
          );
          val = JSON.parse(JSON.stringify(val));
          val.seq = field.seq;
          val.hide = false;
          this.localData.push(val);
        }
        this.localData.sort((a, b) => {
          if (a.seq < b.seq) {
            return -1;
          }
          if (a.seq > b.seq) {
            return 1;
          }
          return 0;
        });
      } else if (
        (field.key == "source" || field.key == "noticePeriod") &&
        val != "other"
      ) {
        let value = this.localData.findIndex(
          (obj) =>
            obj.hide == false &&
            obj.key != field.key &&
            (obj.parentKey == field.key || obj.seq == field.seq)
        );
        if (value != -1) {
          this.localData[value].hide = true;
        }
      }
    },
    columnWidth(data) {
      if (
        data == "text" ||
        data == "email" ||
        data == "single_select" ||
        data == "multi_select" ||
        data == "number" ||
        data == "boolean" ||
        data == "multi_text" ||
        data == "date"
      ) {
        return 4;
      } else if (data == "upload_file") {
        return 9;
      } else {
        return 12;
      }
    },
  },
};
</script>

<style></style>
